import TextField from '@mui/material/TextField'
import styled from '@mui/material/styles/styled'

const CustomTexField = styled(TextField)(() => ({
    borderBottom: "2px solid #DEDEDC",
    '& .MuiInputBase-input': { color: '#F1F1F1' },
    label: { color: '#C9C7C6' },
}))

export default CustomTexField